import {
    INIT_STATE,
    UPDATE_APP_CLICK_TIME,
    UPDATE_APP_POSITION,
} from "../redux_constants/morpheus.state.constant";
import {put_response} from "../helper/request";

export const getNewState = () => {
    return {
        z: 0,
        r: -1,
        x: -1,
        y: -1,
        showGrid: false,
        gridColor: "",
        gridSize: 500,
        gridWidth: 3,
        digitalZoomStatus: false,
        annoColor: "black",
        previewColor: false,
        app_state: {},
        collapse_menu: {},
        apps_initialised: false,
        slide_morphle_id: '',
        slide_id: -1,
        grid_timestamp: -1,
        settings_timestamp: -1,
        annotations_timestamp: -1,
        zoom_timestamp: -1,
        tileCoord: [],
        quadrant: [],
        takeZStack: false,
        numZLevels: -1,
        takeBidirectionalZStack: false,
        selectedShape: null,
        zStackLevel: 0,
        onStitchedLayer: false,
        levelJump: 1,
    }
}

const InitialState = getNewState()

export const viewerUrlReducer = (state = InitialState, action) => {
    let returnableState = {};
    let allAppStates = {};
    let currentAppState = {};
    let newAppState = {};
    switch (action.type) {
        case INIT_STATE:
            returnableState = Object.assign({}, state, action.urlState);
            return returnableState;
        case UPDATE_APP_POSITION:
            allAppStates = state.app_state;
            currentAppState = allAppStates[action.appName] || {};
            newAppState = Object.assign({}, allAppStates, {
                [action.appName]: Object.assign({}, currentAppState, {
                    position: action.appPosition
                })
            });
            returnableState = Object.assign({}, state, {
                app_state: newAppState
            });
            updateAppSettingsInDb(newAppState);
            return returnableState;
        case UPDATE_APP_CLICK_TIME:
            allAppStates = state.app_state;
            currentAppState = allAppStates[action.appName] || {};
            newAppState = Object.assign({}, allAppStates, {
                [action.appName]: Object.assign({}, currentAppState, {
                    clicked_at: new Date().getTime()
                })
            });

            let appVsClickTime = [];

            for (let key in newAppState) {
                appVsClickTime.push({
                    key: key,
                    val: newAppState[key].clicked_at === undefined ? 0 : newAppState[key].clicked_at
                })
            }

            appVsClickTime = appVsClickTime.sort(function (a, b) {
                return a.val - b.val;
            });

            appVsClickTime.forEach((item, index) => {
                newAppState[item.key].zIndex = 9 + 2 * index;
            })

            returnableState = Object.assign({}, state, {
                app_state: newAppState
            });
            updateAppSettingsInDb(newAppState);
            return returnableState;
        default :
            returnableState = state
            return returnableState;
    }
}

export const updateAppSettingsInDb = (app_state, update_zoom_level_flag = false) => {
    let url = `/api/morpheus/settings/` + JSON.parse(localStorage.getItem('morpheus_setting')).id + `/`;
    put_response(url, {app_state})
        .then(response => {
            if (response.status === 200 || response.status === 301 || response.status === 302) {
                if (update_zoom_level_flag) {
                    window.location.reload();
                }
            } else if (response.status === 403 || response.status === 401 || response.status === 400) {
                console.log("Position Update Save Failed", response);
            }
        })
        .catch(err => {
            console.log("Position Update Save Failed, ", err);
        });
}